var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRightThin = function SvgArrowRightThin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 382.4"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8 221h368.8L287.8 331.7c-11.6 11.6-11.6 30.5 0 42 11.6 11.6 30.5 11.6 42 0l161.5-161.5c5.6-5.6 8.7-13.1 8.7-21.1s-3.1-15.5-8.7-21.1L329.8 8.7C324 2.9 316.4 0 308.7 0s-15.3 2.9-21.1 8.7c-11.6 11.6-11.6 30.5 0 42l110.8 110.8H29.8C13.4 161.5 0 174.9 0 191.2S13.3 221 29.8 221"
  })));
};
export default SvgArrowRightThin;